var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        "store-modal": "",
        color: "secondary",
        width: "600px",
        icon: _vm.generateMessagePath("icon"),
        title: _vm.generateMessagePath("title")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "v-btn",
                {
                  staticClass: "mx-5",
                  attrs: {
                    disabled: !_vm.valid,
                    small: "",
                    color: "success",
                    loading: _vm.isEditing
                      ? _vm.isLoadingUpdate
                      : _vm.isLoadingCreate
                  },
                  on: { click: _vm.handleValidateClick }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.generateMessagePath("validate")) +
                      "\n    "
                  )
                ]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "v-form",
        {
          ref: "form",
          attrs: { "lazy-validation": "" },
          on: {
            input: function($event) {
              return _vm.$emit("valid", _vm.valid)
            }
          },
          model: {
            value: _vm.valid,
            callback: function($$v) {
              _vm.valid = $$v
            },
            expression: "valid"
          }
        },
        [
          _c(
            "v-container",
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  !_vm.isEditing
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "8" } },
                        [
                          _c("custom-properties-selector", {
                            attrs: {
                              disabled:
                                _vm.multi_property ||
                                _vm.multiPropertyIsForbidden,
                              dense: "",
                              rules: _vm.multi_property
                                ? []
                                : [
                                    v =>
                                      !!v ||
                                      _vm.generateMessage(
                                        "actionplans.create.noproperty"
                                      )
                                  ],
                              required: !_vm.multi_property
                            },
                            on: { newItem: _vm.handlePropertyChange },
                            model: {
                              value: _vm.item.node_id,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "node_id", $$v)
                              },
                              expression: "item.node_id"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isEditing
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "4" } },
                        [
                          !_vm.multiPropertyIsForbidden
                            ? _c("v-checkbox", {
                                staticClass: "ma-0 pa-0",
                                attrs: {
                                  label: "Plan multi-installations",
                                  "hide-details": ""
                                },
                                model: {
                                  value: _vm.multi_property,
                                  callback: function($$v) {
                                    _vm.multi_property = $$v
                                  },
                                  expression: "multi_property"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isEditing
                    ? _c(
                        "v-col",
                        { attrs: { cols: "12", sm: "6" } },
                        [
                          _c("v-select", {
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              outlined: "",
                              items: _vm.states,
                              "item-text": "name",
                              "item-value": "id",
                              label: _vm.generateMessage(
                                "actionplans.create.action_plan_status"
                              )
                            },
                            model: {
                              value: _vm.item.action_plan_status,
                              callback: function($$v) {
                                _vm.$set(_vm.item, "action_plan_status", $$v)
                              },
                              expression: "item.action_plan_status"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("custom-origin-selector", {
                        attrs: {
                          action_plan_origins: _vm.item.action_plan_origins
                        },
                        on: {
                          "update:action_plan_origins": function($event) {
                            return _vm.$set(
                              _vm.item,
                              "action_plan_origins",
                              $event
                            )
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("custom-text-area", {
                        attrs: {
                          required: "",
                          label:
                            _vm.generateMessage(
                              "actionplans.create.description"
                            ) + " *"
                        },
                        model: {
                          value: _vm.item.description,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "description", $$v)
                          },
                          expression: "item.description"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          outlined: "",
                          items: _vm.types,
                          "item-text": "name",
                          dense: "",
                          "item-value": "id",
                          rules: [
                            v =>
                              (!!v && v !== 3) ||
                              _vm.generateMessage("actionplans.create.notype")
                          ],
                          label:
                            _vm.generateMessage("actionplans.create.type") +
                            " *",
                          required: ""
                        },
                        model: {
                          value: _vm.item.action_plan_type,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "action_plan_type", $$v)
                          },
                          expression: "item.action_plan_type"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6" } },
                    [
                      _c("custom-entity-selector", {
                        attrs: { "item-value": "id", dense: "", required: "" },
                        model: {
                          value: _vm.item.entity_id,
                          callback: function($$v) {
                            _vm.$set(_vm.item, "entity_id", $$v)
                          },
                          expression: "item.entity_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm._v(" "),
      _c("list-action-not-ended", {
        attrs: { items: _vm.statusNotEnded },
        on: { clicked: _vm.validate },
        model: {
          value: _vm.showListActionNotEnded,
          callback: function($$v) {
            _vm.showListActionNotEnded = $$v
          },
          expression: "showListActionNotEnded"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }